import { Link } from 'react-router-dom'
import {
  Bell, Bot, Building2, CalendarClock, ChevronRight, ClipboardList, FileSignature,
  Inbox, LogOut, MessageCircle, MessageSquare, Settings, UsersRound,
} from 'lucide-react'
import { useAuth } from '@/contexts/AuthContext'
import { PAPEL_LABEL } from '@/lib/types'

const ATENDIMENTO = [
  { href: '/atendimento', label: 'Caixa de entrada', icon: Inbox },
  { href: '/atendimento/agenda-ia', label: 'Agenda IA', icon: CalendarClock },
  { href: '/atendimento/chatbot', label: 'Chatbot', icon: Bot },
  { href: '/configuracoes/whatsapp', label: 'Configurações do WhatsApp', icon: MessageCircle },
]

const ITENS = [
  { href: '/notificacoes', label: 'Notificações', icon: Bell },
  { href: '/mensagens', label: 'Mensagens (triagem)', icon: MessageSquare },
  { href: '/protocolos', label: 'Protocolos', icon: ClipboardList },
  { href: '/termos', label: 'Termos', icon: FileSignature },
  { href: '/clinicas', label: 'Clínicas', icon: Building2 },
  { href: '/equipe', label: 'Equipe', icon: UsersRound },
  { href: '/configuracoes', label: 'Configurações', icon: Settings },
]

export default function MaisPage() {
  const { perfil, user, papel, workspaces, current, switchWorkspace, signOut } = useAuth()

  return (
    <div>
      <h1 className="page-title" style={{ marginBottom: 16 }}>Mais</h1>

      <div className="card" style={{ padding: 16, marginBottom: 14 }}>
        <div style={{ fontWeight: 700 }}>{perfil?.nome ?? user?.email}</div>
        <div style={{ fontSize: 13, color: 'var(--muted)' }}>{papel ? PAPEL_LABEL[papel] : ''}</div>
        {workspaces.length > 1 && (
          <select
            className="field-input"
            style={{ marginTop: 10, minHeight: 40 }}
            value={current?.workspace.id ?? ''}
            onChange={e => switchWorkspace(e.target.value)}
            aria-label="Trocar workspace"
          >
            {workspaces.map(w => (
              <option key={w.workspace.id} value={w.workspace.id}>{w.workspace.nome}</option>
            ))}
          </select>
        )}
      </div>

      <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '.04em', margin: '4px 4px 6px' }}>
        Atendimento
      </div>
      <div className="card" style={{ overflow: 'hidden', marginBottom: 14 }}>
        {ATENDIMENTO.map((item, i) => {
          const Icon = item.icon
          return (
            <Link
              key={item.href}
              to={item.href}
              style={{
                display: 'flex', alignItems: 'center', gap: 12, padding: '14px 16px',
                borderTop: i > 0 ? '1px solid var(--border)' : 'none', minHeight: 48,
              }}
            >
              <Icon size={18} aria-hidden style={{ color: 'var(--text-secondary)' }} />
              <span style={{ flex: 1, fontWeight: 500 }}>{item.label}</span>
              <ChevronRight size={16} aria-hidden style={{ color: 'var(--muted)' }} />
            </Link>
          )
        })}
      </div>

      <div className="card" style={{ overflow: 'hidden', marginBottom: 14 }}>
        {ITENS.map((item, i) => {
          const Icon = item.icon
          return (
            <Link
              key={item.href}
              to={item.href}
              style={{
                display: 'flex', alignItems: 'center', gap: 12, padding: '14px 16px',
                borderTop: i > 0 ? '1px solid var(--border)' : 'none', minHeight: 48,
              }}
            >
              <Icon size={18} aria-hidden style={{ color: 'var(--text-secondary)' }} />
              <span style={{ flex: 1, fontWeight: 500 }}>{item.label}</span>
              <ChevronRight size={16} aria-hidden style={{ color: 'var(--muted)' }} />
            </Link>
          )
        })}
      </div>

      <button className="btn-secondary" style={{ width: '100%' }} onClick={() => signOut()}>
        <LogOut size={16} aria-hidden /> Sair
      </button>
    </div>
  )
}
